<template>
  <v-expansion-panel
    v-model="abrir"
    class="filtrosListado"
    popout
  >
    <v-expansion-panel-content>
      <v-card>
        <v-card-text class="v-toolbar__content">
          <v-container
            grid-list-md
            fluid
          >
            <v-layout
              row
              wrap
              v-on:keyup.enter="filtrar"
            >
              <v-flex
                xs12
                sm4
              >
                <v-text-field
                  v-model="filtrosInterno.numero_comprobante"
                  label="Nro. comprobante"
                ></v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-select
                  v-model="filtrosInterno.tipo_comprobante_id"
                  :items="combos.comprobanteTipos"
                  item-text="nombre"
                  item-value="id"
                  label="Tipos Comprobantes"
                ></v-select>
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-select
                  v-model="filtrosInterno.estado_facturacion_id"
                  :items="combos.comprobanteEstados"
                  item-text="nombre"
                  item-value="id"
                  label="Estado"
                ></v-select>
              </v-flex>

              <v-flex
                xs12
                sm3
              >
                <v-text-field
                  v-model="filtrosInterno.fecha_desde"
                  type="date"
                  label="Fecha Desde"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm3
              >
                <v-text-field
                  v-model="filtrosInterno.fecha_hasta"
                  type="date"
                  label="Fecha Hasta"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm3
              >
                <v-select
                  v-model="filtrosInterno.periodo_mes"
                  :items="combos.periodosMeses"
                  item-text="nombre"
                  item-value="id"
                  label="Período Mes"
                ></v-select>
              </v-flex>

              <v-flex
                xs12
                sm3
              >
                <v-select
                  v-model="filtrosInterno.periodo_ano"
                  :items="combos.periodosAnios"
                  item-text="nombre"
                  item-value="id"
                  label="Período Año"
                ></v-select>
              </v-flex>

              <v-flex
                xs12
                sm4
              >
                <v-autocomplete
                  v-model="filtrosInterno.obra_social_id"
                  :items="combos.obrasSociales"
                  item-text="nombre"
                  item-value="id"
                  label="Obra Social"
                  @change="alCambiarOpcion('obra_social_id')"
                ></v-autocomplete>
              </v-flex>

              <v-flex
                xs12
                sm4
              >
                <v-autocomplete
                  v-model="filtrosInterno.obra_social_plan_id"
                  :items="obraSocialPlanes"
                  item-text="nombre"
                  item-value="id"
                  label="Plan"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs12
                sm4
              >
                <v-autocomplete
                  v-model="filtrosInterno.obra_social_plan_facturable_id"
                  :items="facturables"
                  item-text="nombre"
                  item-value="id"
                  label="Prestaciones"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs12
                sm4
                v-if="this.referencia === 'comprobantesEmitidosListado_centro'"
              >
                <v-autocomplete
                  v-model="filtrosInterno.facturado_por_id"
                  :items="combos.instituciones"
                  :item-text="this.$options.filters.nombreCentro"
                  item-value="id"
                  label="Emisor"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                xs12
                sm3
              >
                <v-text-field
                  v-model="filtrosInterno.numero_comprobante_padre"
                  label="Nro. padre"
                ></v-text-field>
              </v-flex>

              <v-flex
                xs12
                sm3
              >
                <v-select
                  v-model="filtrosInterno.saldo"
                  :items="combos.saldo"
                  item-text="nombre"
                  item-value="valor"
                  label="Saldo"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            round
            color="grey lighten-2"
            @click="limpiarFiltros"
          >
            <v-icon
              dark
              small
              class="mr-2"
            >clear</v-icon>
            Limpiar filtros

          </v-btn>
          <v-spacer></v-spacer>
          <botones-cancelar-guardar
            v-bind:mostrar-guardar="true"
            v-bind:guardando="false"
            v-bind:texto-guardar="'Filtrar'"
            v-bind:texto-cancelar="'Cerrar'"
            v-on:alGuardar="filtrar"
            v-on:alCancelar="cerrar"
          ></botones-cancelar-guardar>
        </v-card-actions>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import _ from 'lodash'
import EventBus from '@/helpers/eventBus'
import BotonesCancelarGuardar from '@/components/Botones/BotonesCancelarGuardar'
export default {
  name: 'FacturacionCentroListadoFiltros',
  components: {
    BotonesCancelarGuardar
  },
  props: {
    referencia: {
      type: String,
      required: true
    },
    filtros: {
      type: Object
    },
    combos: {
      type: Object,
      required: true
    }
  },
  computed: {
    obraSocialPlanes () {
      if (this.combos.obrasSociales.length > 0) {
        let obraSocialSeleccionada = _.find(this.combos.obrasSociales, {
          id: this.filtrosInterno.obra_social_id
        })

        return obraSocialSeleccionada && obraSocialSeleccionada.id
          ? _.union([{ id: null, nombre: 'Seleccione' }], obraSocialSeleccionada.planes)
          : [{ id: null, nombre: 'Seleccione' }]
      } else {
        return [{ id: null, nombre: 'Seleccione' }]
      }
    },
    facturables () {
      if (this.obraSocialPlanes.length > 0) {
        let obraSocialPlanSeleccionado = _.find(this.obraSocialPlanes, {
          id: this.filtrosInterno.obra_social_plan_id
        })
        return obraSocialPlanSeleccionado && obraSocialPlanSeleccionado.id
          ? _.union([{ id: null, nombre: 'Seleccione' }], obraSocialPlanSeleccionado.facturables)
          : [{ id: null, nombre: 'Seleccione' }]
      } else {
        return [{ id: null, nombre: 'Seleccione' }]
      }
    }
  },
  data () {
    return {
      abrir: -1,
      filtrosInterno: _.assign({}, this.filtros, {
        numero_comprobante: null,
        estado_facturacion_id: null,
        periodo_mes: null,
        periodo_ano: null,
        tipo_comprobante_id: null,
        fecha_desde: null,
        fecha_hasta: null,
        obra_social_id: null,
        obra_social_plan_id: null,
        facturado_por_id: null,
        numero_comprobante_padre: null,
        obra_social_plan_facturable_id: null,
        saldo: null
      })
    }
  },
  created () {
    let vm = this
    EventBus.$on(this.referencia + ':abrir', () => {
      vm.abrir = vm.abrir === -1 ? 0 : -1
    })
  },
  beforeDestroy () {
    this.abrir = -1
    EventBus.$off(this.referencia + ':abrir')
  },
  mounted () {
    this.combos = _.assign(this.combos, {
      saldo: [
        { valor: null, nombre: 'Seleccione' },
        { valor: 'S', nombre: 'Si' },
        { valor: 'N', nombre: 'No' }
      ]
    })
  },
  methods: {
    filtrar () {
      this.$emit('alFiltrar', this.filtrosInterno)
      this.cerrar()
    },
    cerrar () {
      this.abrir = -1
    },
    alCambiarOpcion (prop) {
      switch (prop) {
        case 'obra_social_id':
          this.filtrosInterno.obra_social_plan_id = null
          this.filtrosInterno.obra_social_plan_facturable_id = null
          break
        case 'obra_social_plan_id':
          this.filtrosInterno.obra_social_plan_facturable_id = null
          break
        default:
          break
      }
    },
    limpiarFiltros () {
      this.filtrosInterno = {
        numero_comprobante: null,
        estado_facturacion_id: null,
        periodo_mes: null,
        periodo_ano: null,
        tipo_comprobante_id: null,
        fecha_desde: null,
        fecha_hasta: null,
        obra_social_id: null,
        obra_social_plan_id: null,
        facturado_por_id: null,
        numero_comprobante_padre: null,
        obra_social_plan_facturable_id: null,
        saldo: null
      }
    }
  }
}
</script>

<style lang="scss">
.filtrosListado {
  .v-expansion-panel__container {
    margin-top: 0 !important;
  }
  .v-expansion-panel__header {
    display: none !important;
  }
}
</style>
